import { lazyRetry } from '@lmt/unicorn-shared/app/helpers/retry-helper';

const UIEditorLazy = lazyRetry(
  () => import(/* webpackChunkName: "UIEditor" */ '../editor/UIEditor'),
);

export { UIEditorLazy };
